import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";

function RenewableAgencyTabs() {
  const { id } = useParams();
  const [overview, setOverview] = useState({});
  const [officials, setOfficials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchAll = async () => {
      try {
        const [overviewRes, officialsRes] = await Promise.all([
          axios.get(`https://backend-zkgn.onrender.com/api/renewable-agencies/${id}`),
          axios.get(
            `https://backend-zkgn.onrender.com/api/renewable-agency-officials/${id}`
          ),
        ]);

        setOverview(overviewRes.data);
        setOfficials(officialsRes.data);
      } catch (err) {
        console.error(err);
        setError("Failed to load agency data.");
      } finally {
        setLoading(false);
      }
    };

    fetchAll();
  }, [id]);

  if (loading) return <div className="text-center my-5">Loading...</div>;
  if (error) return <div className="text-danger my-5">{error}</div>;

  return (
    <div className="container my-5">
      {/* Tabs */}
      <ul className="nav nav-tabs" id="renewableAgencyTab" role="tablist">
        <li className="nav-item">
          <button
            className="nav-link active"
            data-bs-toggle="tab"
            data-bs-target="#overview"
          >
            Overview
          </button>
        </li>
        <li className="nav-item">
          <button
            className="nav-link"
            data-bs-toggle="tab"
            data-bs-target="#officials"
          >
            Officials
          </button>
        </li>
      </ul>

      {/* Tab content */}
      <div className="tab-content p-4 border border-top-0 rounded-bottom shadow-sm">
        {/* Overview */}
        <div className="tab-pane fade show active" id="overview">
          <h4 className="mb-4">Agency Overview</h4>
          <div className="table-responsive">
            <table className="table table-bordered">
              <tbody>
                <tr>
                  <th>Name</th>
                  <td>{overview.renew_agency_name}</td>
                </tr>
                <tr>
                  <th>Address</th>
                  <td>{overview.renew_agency_address}</td>
                </tr>
                <tr>
                  <th>City</th>
                  <td>{overview.renew_agency_city}</td>
                </tr>
                <tr>
                  <th>District</th>
                  <td>{overview.renew_agency_district}</td>
                </tr>
                <tr>
                  <th>State</th>
                  <td>{overview.renew_agency_state}</td>
                </tr>
                <tr>
                  <th>Pincode</th>
                  <td>{overview.renew_agency_pincode}</td>
                </tr>
                <tr>
                  <th>Phone</th>
                  <td>{overview.renew_agency_phone || "N/A"}</td>
                </tr>
                <tr>
                  <th>Email</th>
                  <td>{overview.renew_agency_email || "N/A"}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Officials */}
        <div className="tab-pane fade" id="officials">
          <h4 className="mb-4">Agency Officials</h4>
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Designation</th>
                  <th>Phone</th>
                  <th>Email</th>
                </tr>
              </thead>
              <tbody>
                {officials.length > 0 ? (
                  officials.map((o) => (
                    <tr key={o.renew_official_id}>
                      <td>{o.renew_officials_name}</td>
                      <td>{o.renew_officials_designation}</td>
                      <td>{o.renew_officials_phone || "N/A"}</td>
                      <td>{o.renew_officials_email || "N/A"}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={4} className="text-center">
                      No officials found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RenewableAgencyTabs;
